import { c as _c } from "react/compiler-runtime";
/* istanbul ignore file */

import type { HTMLAttributes } from 'react';
import { styled } from '@classify/react-core-components/styles';
import ButtonBase from '@mui/material/ButtonBase';
import { ChevronRight, ChevronLeft } from '@mui/icons-material';
export interface Props {
  onClick?: () => void;
  direction?: 'left' | 'right';
  isHidden?: boolean;
  translations: {
    previousLabel: string;
    nextLabel: string;
  };
  buttonProps?: HTMLAttributes<HTMLButtonElement>;
}
const noop = () => {};
const ArrowButton = styled(ButtonBase, {
  shouldForwardProp: prop => !['direction', 'isHidden'].includes(prop as string)
})<{
  direction: 'left' | 'right';
  isHidden: boolean;
}>(({
  direction,
  isHidden
}) => ({
  position: 'absolute',
  top: '50%',
  width: 40,
  height: 40,
  transform: 'translateY(-50%)',
  display: isHidden ? 'none' : 'block',
  [direction]: -40,
  cursor: 'pointer'
}));
const ArrowIconLeft = styled(ChevronLeft)(({
  theme: {
    palette
  }
}) => ({
  color: palette.text.onMain
}));
const ArrowIconRight = styled(ChevronRight)(({
  theme: {
    palette
  }
}) => ({
  color: palette.text.onMain
}));
const Arrow = t0 => {
  const $ = _c(11);
  const {
    onClick: t1,
    direction: t2,
    isHidden: t3,
    translations,
    buttonProps: t4
  } = t0;
  const onClick = t1 === undefined ? noop : t1;
  const direction = t2 === undefined ? "left" : t2;
  const isHidden = t3 === undefined ? false : t3;
  let t5;
  if ($[0] !== t4) {
    t5 = t4 === undefined ? {} : t4;
    $[0] = t4;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const buttonProps = t5;
  const t6 = direction === "left" ? translations.previousLabel : translations.nextLabel;
  let t7;
  if ($[2] !== direction) {
    t7 = direction === "left" ? <ArrowIconLeft /> : <ArrowIconRight />;
    $[2] = direction;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== buttonProps || $[5] !== direction || $[6] !== isHidden || $[7] !== onClick || $[8] !== t6 || $[9] !== t7) {
    t8 = <ArrowButton aria-label={t6} onClick={onClick} isHidden={isHidden} direction={direction} disableRipple={true} {...buttonProps}>{t7}</ArrowButton>;
    $[4] = buttonProps;
    $[5] = direction;
    $[6] = isHidden;
    $[7] = onClick;
    $[8] = t6;
    $[9] = t7;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  return t8;
};
export default Arrow;